import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const SeoStrategy = () => {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-11/12 space-y-4 lg:space-y-6 lg:order-2"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">03</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">Technical Team Upskilling</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Deploying AI models is only half the battle; the other half is training your developers and operations teams to use them effectively. We design hands-on workshops tailored to your codebase and technical stack.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        From advanced prompt engineering and API integration strategies for front-end developers to fine-tuning pipelines and secure hosting architectures for infrastructure leads, we establish deep, internal AI capabilities.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-11/12 w-full lg:order-1"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="p-8 rounded-2xl border border-slate-200 dark:border-purple-500/20 bg-white dark:bg-[#202222] shadow-[0_4px_20px_rgba(0,0,0,0.03)] dark:shadow-[0_0_35px_rgba(168,85,247,0.08)] hover-glow transition-all duration-300">
                        <h4 className="text-sm font-semibold mb-6 text-zinc-900 dark:text-white flex items-center space-x-2">
                            <span>Modular Training Pathways</span>
                        </h4>
                        <div className="space-y-3 font-sans text-xs">
                            <div className="p-3 bg-purple-500/5 dark:bg-purple-950/10 rounded-lg border border-purple-500/10 flex justify-between items-center">
                                <div>
                                    <div className="font-semibold text-purple-700 dark:text-purple-300">Prompt Engineering Bootcamp</div>
                                    <div className="text-[10px] text-zinc-500 dark:text-zinc-400 mt-0.5">For Product & Operations Teams</div>
                                </div>
                                <span className="bg-purple-100 dark:bg-purple-950 border border-purple-200 dark:border-purple-500/30 text-purple-700 dark:text-purple-300 px-2 py-0.5 rounded text-[10px] font-medium">1-Week</span>
                            </div>
                            <div className="p-3 bg-purple-500/5 dark:bg-purple-950/10 rounded-lg border border-purple-500/10 flex justify-between items-center">
                                <div>
                                    <div className="font-semibold text-purple-700 dark:text-purple-300">Agent Architectures & LangGraph</div>
                                    <div className="text-[10px] text-zinc-500 dark:text-zinc-400 mt-0.5">For Mid-to-Senior Software Engineers</div>
                                </div>
                                <span className="bg-purple-100 dark:bg-purple-950 border border-purple-200 dark:border-purple-500/30 text-purple-700 dark:text-purple-300 px-2 py-0.5 rounded text-[10px] font-medium">3-Weeks</span>
                            </div>
                            <div className="p-3 bg-purple-500/5 dark:bg-purple-950/10 rounded-lg border border-purple-500/10 flex justify-between items-center">
                                <div>
                                    <div className="font-semibold text-purple-700 dark:text-purple-300">Fine-Tuning & Model Evaluation</div>
                                    <div className="text-[10px] text-zinc-500 dark:text-zinc-400 mt-0.5">For Infrastructure & ML Engineers</div>
                                </div>
                                <span className="bg-purple-100 dark:bg-purple-950 border border-purple-200 dark:border-purple-500/30 text-purple-700 dark:text-purple-300 px-2 py-0.5 rounded text-[10px] font-medium">4-Weeks</span>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default SeoStrategy